import React, { FC } from 'react'

import clsx from 'clsx'
import { getRankClasses } from '../../../../../helpers/helpers'

interface RankNumberProps {
  rank: number
  totalPoints?: number | string | null
  onClick?: () => void
}
export const RankNumber: FC<RankNumberProps> = ({ rank, totalPoints, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'rounded-full text-base flex items-center justify-center w-10 h-10 hover:opacity-70 transition-all',
        getRankClasses({ rank, totalPoints })
      )}
    >
      {rank || 0}
    </button>
  )
}
